import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()(() => ({
  row: {
    ...dFlex(),
    gap: 8,
  },
}));

export default useStyles;
